<template>
  <span>
    <el-tooltip class="item" effect="dark" :content="$t('admin.account.copyConsignees')" placement="top-start">
      <el-button
        id="btn-synchronize-dos"
        v-if="$can(permissions.ADMIN_SETTINGS.SYNCHRONIZE_DOS)"
        type="success"
        plain
        @click="dialogVisible = true"
        size="mini"
      >
        {{ $t('admin.account.copyAccount') }}
      </el-button>
    </el-tooltip>
    <el-dialog
      v-on:open="handleOpen"
      :title="$t('admin.account.copyAccountTitle')"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      class="dialog-with-cols"
    >
      <el-form :model="form" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('admin.account.accountFrom')" prop="accountFrom">
              <autocomplete
                  :model.sync="form.accountFrom"
                  :modelAdditional.sync="form.accountFromName"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlShipper"
                  labelField="name"
                  valueField="id"
                  valueFieldAdditional="name"
                  ref="filterAccountFrom"
                  id="searchForm-accountFrom"
                />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
            <el-form-item :label="$t('admin.account.accountTo')" prop="accountTo">
              <autocomplete
                  :model.sync="form.accountTo"
                  :modelAdditional.sync="form.accountToName"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlShipper"
                  labelField="name"
                  valueField="id"
                  valueFieldAdditional="name"
                  ref="filterAccountTo"
                  id="searchForm-accountTo"
                />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button
          type="primary"
          id="form-save-button"
          @click="handleSearch"
          size="mini"
        >
          {{ $t('common.save') }}
        </el-button>
        <el-button
          id="form-refresh-button"
          @click="resetForm"
          size="mini"
        >
          {{ $t('admin.settings.sage.reset') }}
        </el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import accountService from '@/api/accountService';

export default {
  name: 'CopyAccountConsignee',
  components: {
    Autocomplete,
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        accountFrom: null,
        accountTo: null,
        accountFromName: null,
        accountToName: null
      },
      urlShipper: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
    };
  },
  methods: {
    handleOpen() {
      this.resetForm();
    },
    async handleSearch() {
      Message.closeAll();
      if (!this.form.accountFrom || !this.form.accountTo) {
        this.$message.error(this.$t('admin.account.copyAccountErrorNoSelection'));
        return;
      }
      const confirm = await this.$confirm(this.$t('admin.account.copyAccountConfirmation').replace('{1}', this.form.accountFromName).replace('{2}', this.form.accountToName))
        .catch(() => false);

      if (confirm) {
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        accountService.copyShipperConsignees(this.form.accountFrom, this.form.accountTo)
          .then((response) => {
            this.$message.success(response.message);
          }).finally(() => {
            loading.close();
          });
      }
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.accountFrom = null;
      this.form.accountTo = null;
      this.form.accountFromName = null;
      this.form.accountToName = null;
      this.$refs.filterAccountFrom.clearLocalModel();
      this.$refs.filterAccountTo.clearLocalModel();
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#btn-synchronize-dos {
  margin-right: 10px;
}
</style>
